import React, { Component } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import Stack from "@mui/material/Stack";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import MoarefiIcon from "../../static/icons/moarefi.png";
import Mahsulat from "../../static/icons/mahsulat.png";
import SabtSefaresh from "../../static/icons/sefaresh.png";
import Gallery from "../../static/icons/gallery.png";
import Enteghadat from "../../static/icons/enteghadat.png";
import Hamkari from "../../static/icons/hamkari.png";
import Poshtibani from "../../static/icons/poshtibani.png";
import TamasBaKarshenas from "../../static/icons/tamas.png";
import AkharinNerkh from "../../static/icons/nerkhha.png";

class HomePage extends Component {
  state = {};
  render() {
    const { handleComToShow } = this.props;
    return (
      <Grid item xs={12} mt={5}>
        <Grid
          container
          justifyContent="center"
          spacing={2.5}
          rowSpacing={8}
          //columnSpacing={5}
        >
          {[
            { menuText: "معرفی شرکت", icon: MoarefiIcon, compName: "about" },
            { menuText: "محصولات", icon: Mahsulat, compName: "products" },
            {
              menuText: "ثبت سفارش",
              icon: SabtSefaresh,
              compName: "sabtsefaresh",
            },
            { menuText: "گالری", icon: Gallery, compName: "gallery" },
            {
              menuText: "انتقادات‌و‌پیشنهادات",
              icon: Enteghadat,
              compName: "enteghadat",
            },
            {
              menuText: "همکاری با ما",
              icon: Hamkari,
              compName: "hamkaribama",
            },
            { menuText: "پشتیبانی", icon: Poshtibani, compName: "" },
            {
              menuText: "تماس با کارشناسان",
              icon: TamasBaKarshenas,
              compName: "tamasbakarshenas",
            },
            {
              menuText: "آخرین نرخ‌ها و اخبار",
              icon: AkharinNerkh,
              compName: "news",
            },
          ].map((menuItem, index) => (
            <Grid key={index} item xs={4}>
              <div onClick={() => handleComToShow(menuItem.compName)}>
                <Stack
                  justifyContent="center"
                  alignItems="center"
                  spacing={0.5}
                >
                  <Avatar src={menuItem.icon} sx={{ width: 96, height: 96 }} />
                  <Typography variant="caption">{menuItem.menuText}</Typography>
                </Stack>
              </div>
            </Grid>
          ))}
        </Grid>
      </Grid>
    );
  }
}

export default HomePage;
